import React, { useContext, useEffect, useRef, useState } from 'react'
import { faAngleLeft, faTimes } from '@fortawesome/free-solid-svg-icons'
import { FontAwesomeIcon } from '@fortawesome/react-fontawesome'
import MassiveScrapingCss from '../../../assets/css/components/admin/products/amazon/MassiveScrapingCss'

import axios from 'axios';
import { GlobalContext } from "../../../contexts/GlobalContext";
import { keyAccessToken, keyUserId } from '../../../assets/js/SessionStorageNames';
import { Redirect } from "react-router-dom";
import Routes from '../../../Routes';
import verifyAccessRole from '../../../assets/js/verifyAccessRole';

export default function AnotherScraping() {
    
    const globalContext = useContext(GlobalContext);
    const [redirect, setRedirect] = useState(null);
    const urlRef = useRef(null);
    const [url, setUrl] = useState('');
    const [isLoader, setisloader] = useState(false);

    useEffect(() => {
        const hasAccess = verifyAccessRole(Routes, 61);
        if(!hasAccess) {
            setRedirect(
                <Redirect to={`/admin/dashboard`} />
            )
        }
    },[]);

    const clearInputOne = () => {
        urlRef.current.value = '';
        setUrl('');
    }

    const handleAxiosError = (err, msg = null, consoleLog = true) => {
        if (axios.isCancel(err)) return; //Don't show axios cancel error

        if (err.response && err.response.data) {
            if (err.response.data.message) {
                globalContext.showModalWithMsg(err.response.data.message);
            } else {
                globalContext.showModalWithMsg(err.response.data);
            }
        } else if (msg) {
            globalContext.showModalWithMsg(msg);
        }

        if (consoleLog) console.log("Error: ", err, "Response: ", err.response);
    };

    const scrapProductsResultsUrl = () => {
        const entId = globalContext.currentEnterpriseId;
        if (!entId) {
            globalContext.showModalWithMsg("La empresa...");
            setisloader(false)
            return;
        }
        if (url.length === 0) {
            globalContext.showModalWithMsg("La url no puede estar vacia");
            setisloader(false)
            return;
        }
        setisloader(true)
        
        
        const processCheckIntervalTime = 5000;
        let processModitorId = 0;
        const headers = {
            "x-api-key": process.env.REACT_APP_API_KEY,
            "x-access-token": localStorage.getItem(keyAccessToken),
            "x-user-id": localStorage.getItem(keyUserId),
        };
        
        axios.get(`${process.env.REACT_APP_BACKEND_URL}/v1/product/faceInt/${entId}/${url}`, {
            headers,
           /* params: {
                url: url,
            }*/
        }).then((resp) => {
            globalContext.setLoaderPage(false);
            globalContext.showModalWithMsg("El proceso se esta ejecutando en segundo plano");
            setisloader(false)
        }).catch(err => handleAxiosError(err));
    }

    return (
        <MassiveScrapingCss.cont>
            {redirect}
            <MassiveScrapingCss.header>
            <MassiveScrapingCss.btnBack onClick={() => window.history.back()}>
                <FontAwesomeIcon icon={faAngleLeft} />
            </MassiveScrapingCss.btnBack>
            <MassiveScrapingCss.text size="16pt" fw='500'>
                Robot
            </MassiveScrapingCss.text>
            </MassiveScrapingCss.header>
            <MassiveScrapingCss.contForm>
                <MassiveScrapingCss.headerForm>
                    <MassiveScrapingCss.text size="15pt">
                        Agregue su URL
                    </MassiveScrapingCss.text>
                </MassiveScrapingCss.headerForm>
                <MassiveScrapingCss.bodyForm>
                    <MassiveScrapingCss.contInputAndLabel>
                        <MassiveScrapingCss.text size="12pt">
                            Agregue su URL para el scraping de productos
                        </MassiveScrapingCss.text>
                        <div style={{width:'100%'}} className="d-flex justify-content-end align-items-center">
                            <MassiveScrapingCss.inputOne placeholder="URL" type="text" onChange={(e)=> setUrl(e.target.value)} ref={urlRef} />
                            <MassiveScrapingCss.btnFloat onClick={() => clearInputOne()}>
                                <FontAwesomeIcon icon={faTimes} />
                            </MassiveScrapingCss.btnFloat>
                        </div>
                    </MassiveScrapingCss.contInputAndLabel>
                </MassiveScrapingCss.bodyForm>
                <MassiveScrapingCss.footerForm>
                    <MassiveScrapingCss.btnSave onClick={() => scrapProductsResultsUrl()} disabled={isLoader}>
                        {
                            isLoader ? 
                                'Cargando...'
                            :
                            'Iniciar'
                        }
                    </MassiveScrapingCss.btnSave>
                </MassiveScrapingCss.footerForm>
            </MassiveScrapingCss.contForm>
        </MassiveScrapingCss.cont>
    )
}

